import React from 'react';
import { X } from 'lucide-react';

interface FilterPanelProps {
  selectedCategories: string[];
  onCategoryToggle: (category: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

const categories = [
  { id: 'restaurant', label: 'Restaurants', icon: '🍽️' },
  { id: 'tech', label: 'Technology', icon: '💻' },
  { id: 'retail', label: 'Retail', icon: '🛒' },
  { id: 'service', label: 'Services', icon: '🔧' },
  { id: 'hotel', label: 'Hotels', icon: '🏨' },
  { id: 'entertainment', label: 'Entertainment', icon: '🎮' },
];

export const FilterPanel: React.FC<FilterPanelProps> = ({
  selectedCategories,
  onCategoryToggle,
  isOpen,
  onClose
}) => {
  // MODIFICATION: Instead of returning null, we use CSS classes to transition the panel's visibility and height.
  return (
    <div
      className={`absolute top-full left-0 right-0 mt-2 z-50 transition-all duration-300 ease-in-out overflow-hidden ${
        isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
      }`}
    >
      <div className="bg-gray-900/95 backdrop-blur-sm border border-gray-700 rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white">Filter by Category</h3>
          <button
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryToggle(category.id)}
              className={`flex items-center gap-3 p-3 rounded-lg border transition-all duration-200 ${
                selectedCategories.includes(category.id)
                  ? 'bg-orange-500/20 border-orange-500 text-orange-300'
                  : 'bg-gray-800/50 border-gray-700 text-gray-300 hover:bg-gray-700/50 hover:border-gray-600'
              }`}
            >
              <span className="text-xl">{category.icon}</span>
              <span className="font-medium">{category.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};